// extracted by mini-css-extract-plugin
export default {"error-boundary-margin-top":"error-boundary-margin-top-RDo9f"};